/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './menses-event.reducer';

export const MensesEventDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mensesEventEntity = useAppSelector(state => state.mensesEvent.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mensesEventDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mensesEvent.detail.title">MensesEvent</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.id">Id</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.id}</dd>
          <dt>
            <span id="estimatedStartDate">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.estimatedStartDate">Estimated Start Date</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.estimatedStartDate}</dd>
          <dt>
            <span id="actualStartDate">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.actualStartDate">Actual Start Date</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.actualStartDate}</dd>
          <dt>
            <span id="estimatedEndDate">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.estimatedEndDate">Estimated End Date</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.estimatedEndDate}</dd>
          <dt>
            <span id="actualEndDate">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.actualEndDate">Actual End Date</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.actualEndDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.status">Status</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.status}</dd>
          <dt>
            <span id="comments">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.comments">Comments</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.comments}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.active">Active</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.mensesEvent.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{mensesEventEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mensesEvent.patient">Patient</Translate>
          </dt>
          <dd>{mensesEventEntity.patient ? mensesEventEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mensesEvent.gynaecHistory">Gynaec History</Translate>
          </dt>
          <dd>{mensesEventEntity.gynaecHistory ? mensesEventEntity.gynaecHistory.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/menses-event" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/menses-event/${mensesEventEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MensesEventDetail;
